/**
 * Segmento tomado desde es.js de moment
 * @type {Array}
 */
let monthsShortDot = 'Ene._Feb._Mar._Abr._May._Jun._Jul._Ago._Sep._Oct._Nov._Dic.'.split('_')
let monthsShort = 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_')

let monthsParse = [/^Ene/i, /^Feb/i, /^Mar/i, /^Abr/i, /^May/i, /^Jun/i, /^Jul/i, /^Ago/i, /^Sep/i, /^Oct/i, /^Nov/i, /^Dic/i]
let monthsRegex = /^(Enero|Febrero|Marzo|Abril|Mayo|Junio|Julio|Agosto|Septiembre|Octubre|Noviembre|Diciembre|Ene\.?|Feb\.?|Mar\.?|Abr\.?|May\.?|Jun\.?|Jul\.?|Ago\.?|Sep\.?|Oct\.?|Nov\.?|Dic\.?)/i

moment.defineLocale('es', {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  monthsShort: function (m, format) {
    if (!m) {
      return monthsShortDot
    } else if (/-MMM-/.test(format)) {
      return monthsShort[m.month()]
    } else {
      return monthsShortDot[m.month()]
    }
  },
  monthsRegex: monthsRegex,
  monthsShortRegex: monthsRegex,
  monthsStrictRegex: /^(Enero|Febrero|Marzo|Abril|Mayo|Junio|Julio|Agosto|Septiembre|Octubre|Noviembre|Diciembre)/i,
  monthsShortStrictRegex: /^(Ene\.?|Feb\.?|Mar\.?|Abr\.?|May\.?|Jun\.?|Jul\.?|Ago\.?|Sep\.?|Oct\.?|Nov\.?|Dic\.?)/i,
  monthsParse: monthsParse,
  longMonthsParse: monthsParse,
  shortMonthsParse: monthsParse,
  weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
  weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
  weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D [de] MMMM [de] YYYY',
    LLL: 'D [de] MMMM [de] YYYY H:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
  },
  calendar: {
    sameDay: function () {
      return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT'
    },
    nextDay: function () {
      return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT'
    },
    nextWeek: function () {
      return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT'
    },
    lastDay: function () {
      return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT'
    },
    lastWeek: function () {
      return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT'
    },
    sameElse: 'L'
  },
  relativeTime: {
    future: 'en %s',
    past: 'hace %s',
    s: 'unos segundos',
    ss: '%d segundos',
    m: 'un minuto',
    mm: '%d minutos',
    h: 'una hora',
    hh: '%d horas',
    d: 'un día',
    dd: '%d días',
    M: 'un mes',
    MM: '%d meses',
    y: 'un año',
    yy: '%d años'
  },
  dayOfMonthOrdinalParse: /\d{1,2}º/,
  ordinal: '%dº',
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  }
})



// WEBPACK FOOTER //
// ./src/util/MomentLocale.js